/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/Tag/theme';

export const TagTheme = theme;
